import withEntry from '../../../components/shared/withEntry';
import withModalEntry from '../../../components/shared/EntryWrapper';
import { EntryTypes } from '../../../utils/types/entry';

export const CurrencySelectionModalEntry = withEntry(withModalEntry(EntryTypes.currencySelectionTrigger));
